import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";

interface FallbackProps {
  error: unknown;
  resetError: () => void;
}

function DefaultFallback({ resetError }: FallbackProps) {
  return (
    <div
      role="alert"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        fontFamily: "'Plus Jakarta Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        background: "#f7f8f1",
        color: "#111111",
      }}
    >
      <div style={{ maxWidth: 480, textAlign: "center" }}>
        <h1 style={{ fontSize: "clamp(28px, 4vw, 40px)", fontWeight: 700, marginBottom: 12 }}>
          Something went wrong.
        </h1>
        <p style={{ color: "#4a4a4a", marginBottom: 24, lineHeight: 1.6 }}>
          We logged the issue. Please refresh, or click below to retry from here.
        </p>
        <button
          onClick={resetError}
          style={{
            background: "#8cd55f",
            color: "#111",
            padding: "12px 24px",
            borderRadius: 999,
            border: "none",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={DefaultFallback as never}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
